import { render, staticRenderFns } from "./instSbp.vue?vue&type=template&id=34013fb8&scoped=true"
import script from "./instSbp.vue?vue&type=script&lang=js"
export * from "./instSbp.vue?vue&type=script&lang=js"
import style0 from "./instSbp.vue?vue&type=style&index=0&id=34013fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34013fb8",
  null
  
)

export default component.exports